import { render, staticRenderFns } from "./Injects.vue?vue&type=template&id=fea7227e&scoped=true&"
import script from "./Injects.vue?vue&type=script&lang=js&"
export * from "./Injects.vue?vue&type=script&lang=js&"
import style0 from "./Injects.vue?vue&type=style&index=0&id=fea7227e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea7227e",
  null
  
)

export default component.exports